import {useEffect} from 'react';

import usePayment from '../../providers/usePayment';
import useProjects from '../../providers/useProjects';
import useWorkspaces from '../../providers/useWorkspaces';

const useRefetchAfterAdminModeToggling = () => {
  const {fetchProjects} = useProjects();
  const {shouldRefetchAfterAdminModeToggling, setShouldRefetchAfterAdminModeToggling, getUserSubscriptionStatus} = usePayment();
  const {getWorkspaces} = useWorkspaces();

  useEffect(() => {
    (async () => {
      if (shouldRefetchAfterAdminModeToggling) {
        await Promise.all([getWorkspaces(), getUserSubscriptionStatus(true), fetchProjects()]);
        setShouldRefetchAfterAdminModeToggling(false);
      }
    })();
  }, [shouldRefetchAfterAdminModeToggling]);
};

export default useRefetchAfterAdminModeToggling;
